
// Mapping du contenu SEO pour chaque département
export const departmentSEOData: Record<string, {title: string, services: string[], zones: string[]}> = {
  '46': {
    title: "Services de gestion des déchets dans le Lot (46)",
    services: [
      "Location de bennes et conteneurs",
      "Collecte des déchets industriels",
      "Recyclage et valorisation",
      "Achat de métaux et ferrailles",
      "Démolition et démantèlement"
    ],
    zones: ["Cahors", "Figeac", "Gourdon", "Saint-Céré", "Gramat", "Souillac", "Prayssac", "Puy-l'Évêque"]
  },
  '12': {
    title: "Services de gestion des déchets en Aveyron (12)",
    services: [
      "Location de bennes de toutes capacités",
      "Récupération et recyclage de métaux",
      "Valorisation des déchets industriels",
      "Services pour professionnels et collectivités",
      "Tri et gestion des DIB"
    ],
    zones: ["Rodez", "Millau", "Villefranche-de-Rouergue", "Decazeville", "Saint-Affrique", "Espalion", "Onet-le-Château"]
  },
  '81': {
    title: "Services de gestion des déchets dans le Tarn (81)",
    services: [
      "Collecte et traitement des déchets industriels",
      "Valorisation des matières recyclables",
      "Location de conteneurs adaptés",
      "Rachat de métaux et matériaux",
      "Solutions sur mesure pour entreprises"
    ],
    zones: ["Albi", "Castres", "Mazamet", "Gaillac", "Lavaur", "Graulhet", "Carmaux", "Saint-Sulpice"]
  },
  '11': {
    title: "Services de gestion des déchets dans l'Aude (11)",
    services: [
      "Collecte professionnelle de déchets",
      "Tri et valorisation matière",
      "Location de bennes pour chantiers",
      "Rachat de ferrailles et métaux",
      "Conseil en gestion des déchets"
    ],
    zones: ["Carcassonne", "Narbonne", "Castelnaudary", "Limoux", "Lézignan-Corbières", "Port-la-Nouvelle"]
  },
  '31': {
    title: "Services de gestion des déchets en Haute-Garonne (31)",
    services: [
      "Collecte et valorisation des déchets",
      "Location de bennes et compacteurs",
      "Traitement des déchets dangereux et non dangereux",
      "Rachat de métaux et matériaux recyclables",
      "Solutions environnementales pour entreprises"
    ],
    zones: ["Toulouse", "Muret", "Saint-Gaudens", "Colomiers", "Tournefeuille", "Blagnac", "Cugnaux", "Plaisance-du-Touch"]
  },
  '34': {
    title: "Services de gestion des déchets dans l'Hérault (34)",
    services: [
      "Gestion intégrée des déchets",
      "Location de matériel de collecte",
      "Récupération et valorisation des matériaux",
      "Solutions pour chantiers et événements",
      "Services pour collectivités et entreprises"
    ],
    zones: ["Montpellier", "Béziers", "Sète", "Agde", "Lunel", "Frontignan", "Lattes", "Mauguio"]
  },
  '15': {
    title: "Services de gestion des déchets dans le Cantal (15)",
    services: [
      "Collecte de déchets professionnels",
      "Valorisation et recyclage",
      "Location de bennes tous volumes",
      "Rachat de métaux et matériaux",
      "Solutions pour zones rurales et urbaines"
    ],
    zones: ["Aurillac", "Saint-Flour", "Mauriac", "Arpajon-sur-Cère", "Riom-ès-Montagnes", "Ytrac"]
  },
  '48': {
    title: "Services de gestion des déchets en Lozère (48)",
    services: [
      "Collecte adaptée aux zones rurales",
      "Gestion des déchets industriels",
      "Location de conteneurs et bennes",
      "Valorisation des déchets agricoles",
      "Solutions pour collectivités rurales"
    ],
    zones: ["Mende", "Marvejols", "Florac", "Saint-Chély-d'Apcher", "Langogne", "La Canourgue"]
  },
  '95': {
    title: "Services de gestion des déchets dans le Val-d'Oise (95)",
    services: [
      "Gestion des déchets en milieu urbain",
      "Solutions pour entreprises et collectivités",
      "Location de matériel de collecte",
      "Valorisation et recyclage avancés",
      "Traitement des déchets spécifiques"
    ],
    zones: ["Cergy", "Argenteuil", "Sarcelles", "Garges-lès-Gonesse", "Gonesse", "Bezons", "Pontoise", "Beauchamp"]
  },
  '30': {
    title: "Services de gestion des déchets dans le Gard (30)",
    services: [
      "Collecte et traitement des déchets",
      "Location de bennes tous volumes",
      "Valorisation et recyclage des matériaux",
      "Solutions pour professionnels et collectivités",
      "Rachat de ferraille et métaux"
    ],
    zones: ["Nîmes", "Alès", "Bagnols-sur-Cèze", "Beaucaire", "Villeneuve-lès-Avignon", "Saint-Gilles", "Uzès", "Le Grau-du-Roi"]
  },
  '82': {
    title: "Services de gestion des déchets en Tarn-et-Garonne (82)",
    services: [
      "Solutions de gestion des déchets",
      "Location de bennes pour chantiers",
      "Collecte et valorisation",
      "Rachat de métaux et matériaux",
      "Services adaptés aux entreprises et collectivités"
    ],
    zones: ["Montauban", "Castelsarrasin", "Moissac", "Caussade", "Valence", "Verdun-sur-Garonne"]
  },
  '93': {
    title: "Services de gestion des déchets en Seine-Saint-Denis (93)",
    services: [
      "Gestion des déchets en zone urbaine dense",
      "Location de bennes et compacteurs",
      "Solutions pour chantiers et entreprises",
      "Valorisation et recyclage optimisés",
      "Collecte adaptée aux contraintes urbaines"
    ],
    zones: ["Saint-Denis", "Montreuil", "Aubervilliers", "Aulnay-sous-Bois", "Bobigny", "Pantin", "Drancy", "Noisy-le-Grand"]
  },
  '92': {
    title: "Services de gestion des déchets dans les Hauts-de-Seine (92)",
    services: [
      "Solutions environnementales adaptées",
      "Collecte et valorisation des déchets",
      "Location de bennes professionnelles",
      "Gestion optimisée pour zones urbaines",
      "Services pour entreprises et collectivités"
    ],
    zones: ["Nanterre", "Boulogne-Billancourt", "Colombes", "Asnières-sur-Seine", "Rueil-Malmaison", "Courbevoie", "Levallois-Perret"]
  },
  '75': {
    title: "Services de gestion des déchets à Paris (75)",
    services: [
      "Solutions urbaines de gestion des déchets",
      "Collecte spécialisée pour la capitale",
      "Location de conteneurs adaptés",
      "Valorisation et recyclage optimisés",
      "Services pour professionnels en milieu dense"
    ],
    zones: ["Paris Centre", "Paris Nord", "Paris Est", "Paris Ouest", "Paris Sud", "Tous les arrondissements"]
  },
  '78': {
    title: "Services de gestion des déchets dans les Yvelines (78)",
    services: [
      "Solutions complètes de gestion des déchets",
      "Location de bennes tous formats",
      "Collecte et valorisation matière",
      "Services pour zones urbaines et rurales",
      "Solutions pour entreprises et collectivités"
    ],
    zones: ["Versailles", "Saint-Germain-en-Laye", "Mantes-la-Jolie", "Sartrouville", "Poissy", "Rambouillet", "Conflans-Sainte-Honorine"]
  },
  '43': {
    title: "Services de gestion des déchets en Haute-Loire (43)",
    services: [
      "Solutions de collecte adaptées",
      "Location de bennes pour professionnels",
      "Valorisation des déchets",
      "Rachat de métaux et matériaux",
      "Services pour zones rurales et semi-urbaines"
    ],
    zones: ["Le Puy-en-Velay", "Brioude", "Yssingeaux", "Monistrol-sur-Loire", "Sainte-Sigolène", "Langeac"]
  },
  '63': {
    title: "Services de gestion des déchets dans le Puy-de-Dôme (63)",
    services: [
      "Gestion intégrée des déchets",
      "Location de bennes professionnelles",
      "Collecte et valorisation",
      "Solutions pour entreprises et collectivités",
      "Rachat de métaux et ferrailles"
    ],
    zones: ["Clermont-Ferrand", "Riom", "Issoire", "Thiers", "Cournon-d'Auvergne", "Chamalières", "Pont-du-Château"]
  }
};
